import * as types from "./constants";

const initialState = {
  queue: [],
  timelinePhases: [],
  progress: { completed: 0, total: 0, percentage: 0 },
  queueLoading: false,
  dismissing: false,
  restoring: false,
  currentTemplateId: null,
  templateGovernanceItems: [],
  templateGovernanceLoading: false,
};

const OnboardingBuilderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ONBOARDING_QUEUE:
      return { ...state, queueLoading: true };
    case types.FETCH_ONBOARDING_QUEUE_SUCCESS:
      return {
        ...state,
        queueLoading: false,
        queue: action.payload?.queue || [],
        timelinePhases: action.payload?.timeline_phases || [],
        progress: action.payload?.progress || initialState.progress,
      };
    case types.FETCH_ONBOARDING_QUEUE_FAILURE:
      return { ...state, queueLoading: false };

    case types.DISMISS_QUEUE_ITEM:
      return { ...state, dismissing: true };
    case types.DISMISS_QUEUE_ITEM_SUCCESS:
      return { ...state, dismissing: false };
    case types.DISMISS_QUEUE_ITEM_FAILURE:
      return { ...state, dismissing: false };

    case types.RESTORE_QUEUE_ITEM:
      return { ...state, restoring: true };
    case types.RESTORE_QUEUE_ITEM_SUCCESS:
      return { ...state, restoring: false };
    case types.RESTORE_QUEUE_ITEM_FAILURE:
      return { ...state, restoring: false };

    case types.FETCH_TEMPLATE_GOVERNANCE:
      return { ...state, templateGovernanceLoading: true };
    case types.FETCH_TEMPLATE_GOVERNANCE_SUCCESS:
      return {
        ...state,
        templateGovernanceLoading: false,
        templateGovernanceItems: action.payload || [],
      };
    case types.FETCH_TEMPLATE_GOVERNANCE_FAILURE:
      return {
        ...state,
        templateGovernanceLoading: false,
        templateGovernanceItems: [],
      };

    case types.SET_CURRENT_TEMPLATE:
      return {
        ...state,
        currentTemplateId: action.payload,
        templateGovernanceItems: [],
      };

    case types.RESET_BUILDER:
      return { ...initialState };

    default:
      return state;
  }
};

export default OnboardingBuilderReducer;
